(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Events.EventsSummary.Cumulative.TotalsView",
                    {
                        url: "/Totals/:TotalType/:EventType",
                        component: "totalsView",
                        PageTitle: "Cumulative Totals | Marketing Tracker",
                        resolve: {
                            user: ["userApi", function (userApi) {
                                return userApi.getLoggedInUser().then(function (user) {
                                    return {
                                        UserId: user.Id,
                                        User: user
                                    };
                                });
                            }],
                            onBehalfOfUser: ["userApi", "permissionService", function (userApi, permissionService) {
                                var onBehalfOfUserId = permissionService.getOnBehalfOfUserId();
                                if (onBehalfOfUserId)
                                    return userApi.get(onBehalfOfUserId).catch(ng.noop);
                                return null;
                            }]
                        }
                        
                    });
        }
    ]);

    app
        .component("totalsView",
            {
                templateUrl: "App/Tools/MarketingTrackerNew/Events/EventsSummary/Cumulative/TotalsView/totals-view-template.html",
                controller: totalsViewController,
                bindings: {
                    user: "<",
                    eventTypes: "<",
                    onBehalfOfUser: "<",
                    summaryYear: "<"
                }
            });

    totalsViewController.$inject = ["_", "$filter", "$stateParams", "marketingTrackerApi", "marketingTrackerAuthService", "userApi", "marketingTrackerEventGroupApi", "moment", "figToaster"];
    function totalsViewController(_, $filter, $stateParams, marketingTrackerApi, marketingTrackerAuthService, userApi, marketingTrackerEventGroupApi, moment, figToaster) {
        var $ctrl = this;
    
        ng.extend($ctrl, {
            toggleSort: toggleSort,
            totalTypeBehaviors: {
                TotalInsuranceBusinessClosed: {
                    FilterFn: function (event) {
                        return event.TotalInsuranceBusinessClosed > 0;
                    }
                },
                TotalAumBusinessClosed: {
                    FilterFn: function (event) {
                        return event.TotalAumBusinessClosed > 0;
                    }
                },
                TotalAssetsClosed: {                  
                    FilterFn: function (event) {
                        return event.TotalAssetsClosed > 0;
                    }                  
                },
                TotalCommission: {
                    FilterFn: function (event) {
                        return event.TotalCommission > 0;
                    }
                },
                TotalEventCost: {
                    FilterFn: function (event) {
                        return event.TotalEventCost > 0;
                    }
                }
            },
            ui: {
                eventTypeOptions: $filter("orderBy")($ctrl.eventTypes.ClientEvents.types),
                loadingData: false
            }
        });
        
        function toggleSort(propertyName) {
            $ctrl.reverseOrder = $ctrl.propertyName === propertyName ? !$ctrl.reverseOrder : false;
            $ctrl.propertyName = propertyName;
        }

        function _selectedUser() {
            if ($ctrl.onBehalfOfUser) {
                return {
                    UserId: $ctrl.onBehalfOfUser.Id,
                    User: $ctrl.onBehalfOfUser
                };
            }
            return $ctrl.user;
        }

        function _getUserEvents(figAuthUserId) {
            var startDate = moment(new Date($ctrl.summaryYear, 0, 1)).toISOString();
            var endDate = moment(new Date($ctrl.summaryYear + 1, 0, 1)).toISOString();
            return _getUserEventsByDate(figAuthUserId, $ctrl.eventTypeList, startDate, endDate, null);
        }

        function _getUserEventsByDate(figAuthUserId, eventTypes, startDate, endDate, nextPageToken) {
            return marketingTrackerEventGroupApi
                .getUserEventGroupsByDate(eventTypes, startDate, endDate, nextPageToken).then(
                    function (events) {
                        if (!events.NextPage) return events;
                        return _getUserEventsByDate(figAuthUserId, eventTypes, startDate, endDate, events.NextPage).then(
                            function (recursiveEvents) {
                                return events = _.concat(events, recursiveEvents);
                            });
                    });
        }

        function _setDisplayEventList(events) {
            $ctrl.displayEventsList = _.chain(events)
                .filter($ctrl.totalTypeBehaviors[$ctrl.selectedTotalType].FilterFn)
                .map(function (event) {                  
                    return {
                        Id: event.Id,
                        EventId: event.EventId,
                        Title: event.EventTitle,
                        Date: event.EventDate,
                        Venue: event.EventVenue,
                        Category: event.EventType.Category,
                        Type: event.EventType.Name,
                        Total: event[$ctrl.selectedTotalType]
                    };
                })
                .value();

            return $ctrl.displayEventsList;
        }

        function _setEventTotalsSum(displayEvents) {
           
            $ctrl.eventTotalsSum = _.reduce(_.uniqBy(displayEvents, function (row) { return row.Id; }),
                function (acc, item) {
                    return acc + item.Total;
                }, 0);
            return $ctrl.eventTotalsSum;
        }

        function _setEvents(events) {        
            $ctrl.events = events;
            return $ctrl.events;
        }

        function _setFigAuthUserId(figAuthUser) {
            $ctrl.figAuthUserId = figAuthUser.FigAuthUserId;
            return $ctrl.figAuthUserId;
        }

        function _getFigAuth(token) {
            marketingTrackerAuthService.setAccessToken(token);
            return userApi.getFigAuth(_selectedUser().UserId);
        }


        $ctrl.$onInit = function () {

            $ctrl.ui.loadingData = true;
            $ctrl.selectedTotalType = $stateParams.TotalType;
            $ctrl.eventType = $stateParams.EventType;

            $ctrl.summaryYear = parseInt($stateParams.SummaryYear);

            $ctrl.eventTypeList = _.chain($ctrl.eventTypes)
                .pickBy(function (val, key) { return $ctrl.eventType !== 'All' ? key === $ctrl.eventType : key !== 'Referrals' && key !== 'Cumulative'; })
                .values()
                .reduce(function (arr, item) {
                        return _.chain(item.types)
                            .filter(function(t) { return t !== "All"; })
                            .concat(arr)
                            .value();
                    },
                    [])
                .value();         

            marketingTrackerApi.getToken($ctrl.user.UserId)
                .then(_getFigAuth)
                .then(_setFigAuthUserId)
                .then(_getUserEvents)
                .then(_setEvents)
                .then(_setDisplayEventList)
                .then(_setEventTotalsSum)
                .catch(function(error) {
                    console.log("Error: " + error.data);
                    message = "There was a problem updating your data. Please try again shortly.";
                    toastClass = "is-error";
                    figToaster.showSimple(message, "top", toastClass);
                })
                .finally(function() {
                    $ctrl.ui.loadingData = false;
                });
        };
    }

})(window.app, window.angular); //jshint ignore:line